import { useSelector } from 'react-redux'
import { getHasAllCustomersAccess } from '../../_augmentt/selectors/userPermissions'

const useUserAccessTier = () => {
  const hasAllCustomersAccess = useSelector(getHasAllCustomersAccess)
  const hasMultiCspSubscription = useSelector(({ meta }) => meta?.hasMultiCspSubscription)

  // and org admin is an user who have access to all customers (customers=[0])
  const isOrgAdminUser = hasAllCustomersAccess

  // a soc admin is an org admin in a multi csp environment
  const isSocAdminUser = isOrgAdminUser && hasMultiCspSubscription

  return {
    isOrgAdminUser,
    isSocAdminUser,
  }
}

export default useUserAccessTier
